import LaunchIcon from '@mui/icons-material/Launch'
import {
    Button,
    Card,
    CardContent,
    FormControl,
    FormHelperText,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { useStoreState } from 'pullstate'
import { useEffect, useMemo, useState } from 'react'
import BackdropLoader from '../../components/BackdropLoader.jsx'
import RichtextFormatter from '../../components/RichtextFormatter.jsx'
import { AppStore } from '../../stores/AppStore.js'
import {
    createPeopleBuilderSettings,
    getUserPeopleBuilderSettings,
    updatePeopleBuilderSettings
} from '../../utils/newPeopleBuilderSettingsUtils.js'

const NewPeopleBuilderSettings = (props) => {
    const [startDate, setStartDate] = useState(null)
    const openAlert = useStoreState(AppStore, s => s.snackbar.openAlert);
    const { pbSettings } = useStoreState(AppStore)
    const {
        peopleBuilderId, setOpenPeopleBuilderForm,
        peopleBuilderSettings, setPeopleBuilderSettings
    } = props || null
    const [endDate, setEndDate] = useState(null)
    const [midYearDate, setMidYearDate] = useState('')
    const [endYearDate, setEndYearDate] = useState('')
    const [emailText, setEmailText] = useState('')
    const [slackObject, setSlackObject] = useState({
        title: '',
        message: ''
    })
    const [openBackdrop, setOpenBackdrop] = useState(false)
    const [url, setUrl] = useState('')
    const [pbData, setPbData] = useState({
        start_date: undefined,
        end_date: undefined,
        mid_year_checkin: undefined,
        end_year_checkin: undefined,
        file_url: undefined,
        email_message: undefined,
        slack_message: undefined,
    })
    const months = useMemo(() => ([
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ]))
    const [monthsEndYearCheckin, setMonthsEndYearCheckin] = useState([])
    const [startDateEmpty, setStartDateEmpty] = useState({ error: false, errorText: '' })
    const [endDateEmpty, setEndDateEmpty] = useState({ error: false, errorText: '' })
    const [midYearEmpty, setMidYearEmpty] = useState({ error: false, errorText: '' })
    const [endYearEmpty, setEndYearEmpty] = useState({ error: false, errorText: '' })
    const [pdfEmpty, setPdfEmpty] = useState({ error: false, errorText: '' })

    useEffect(() => {
        if (peopleBuilderId && pbSettings) {
            getUserPeopleBuilderSettings({
                pbSettings,
                peopleBuilderId,
                months,
                setOpenBackdrop,
                setStartDate,
                setEndDate,
                setMidYearDate,
                setEndYearDate,
                setUrl,
                setEmailText,
                setPbData,
                setSlackObject
            })
        }
    }, [peopleBuilderId])

    useEffect(() => {
        if (peopleBuilderId && pbSettings)
            setPbData(prevStates => ({
                ...prevStates,
                start_date: startDate,
                end_date: endDate
            }))
    }, [peopleBuilderId])

    return (
        <Card sx={{ boxShadow: 3, marginBottom: 2 }}>
            <BackdropLoader openBackdrop={openBackdrop} />
            <CardContent>
                <FormControl fullWidth sx={{ m: 0 }} >
                    <Stack direction="row" spacing={1}>
                        <LocalizationProvider
                            dateAdapter={AdapterMoment}
                        >
                            <DatePicker
                                required={true}
                                label="Start Date"
                                value={startDate}
                                views={['year', 'month', 'day']}
                                sx={{ width: '50%' }}
                                onChange={(newValue) => {
                                    setStartDate(newValue)
                                    setPbData(prevStates => ({ ...prevStates, start_date: newValue }))
                                    setStartDateEmpty({ error: false, errorText: '' })
                                }}
                                renderInput={(params) => <TextField {...params} />}
                                format='YYYY-MM-DD'
                                slotProps={{
                                    textField: {
                                        required: true,
                                        helperText: startDateEmpty.errorText,
                                        error: startDateEmpty.error
                                    }
                                }}
                            />
                        </LocalizationProvider>

                        <LocalizationProvider
                            dateAdapter={AdapterMoment}
                        >
                            <DatePicker
                                label="End Date"
                                value={endDate}
                                sx={{ width: '50%' }}
                                views={['year', 'month', 'day']}
                                onChange={(newValue) => {
                                    setEndDate(newValue)
                                    setPbData(prevStates => ({ ...prevStates, end_date: newValue }))
                                    setEndDateEmpty({ error: false, errorText: '' })

                                }}
                                renderInput={(params) => <TextField {...params} />}
                                format='YYYY-MM-DD'
                                slotProps={{
                                    textField: {
                                        required: true,
                                        helperText: endDateEmpty.errorText,
                                        error: endDateEmpty.error
                                    }
                                }}
                            />

                        </LocalizationProvider>
                    </Stack>
                    <Stack direction='row' spacing={2} mt={4}>

                        <FormControl
                            sx={{ width: '50%' }}
                            id="outlined-basic"
                            variant="outlined"
                            required
                            error={midYearEmpty.error}

                        >
                            <InputLabel>Mid-Year Check-In</InputLabel>
                            <Select
                                value={midYearDate}
                                label='Mid-Year Check-In'
                                onChange={(e) => {
                                    const monthSelected = months.indexOf(e.target.value)
                                    const monthsMid = Array.from(months)
                                    setMidYearEmpty({ error: false, errorText: '' })
                                    setMidYearDate(e.target.value)
                                    setMonthsEndYearCheckin(monthsMid.splice(monthSelected, months.length))
                                    startDate ? (
                                        setPbData(prevStates => ({
                                            ...prevStates,
                                            mid_year_checkin: moment.utc({
                                                year: startDate.year(),
                                                month: monthSelected,
                                                day: 1
                                            }).format('YYYY-MM-DD')
                                        }))

                                    ) : (
                                        setPbData(prevStates => ({
                                            ...prevStates,
                                            mid_year_checkin: moment.utc({
                                                year: new Date().getFullYear(),
                                                month: monthSelected,
                                                day: 1
                                            }).format('YYYY-MM-DD')
                                        }))

                                    )
                                }}
                            >
                                {months.map((month, index) => (
                                    <MenuItem key={index} value={month}>{month}</MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>{midYearEmpty.errorText}</FormHelperText>
                        </FormControl>
                        <FormControl
                            sx={{ width: '50%' }}
                            id="outlined-basic"
                            variant="outlined"
                            required
                            error={endYearEmpty.error}
                        >
                            <InputLabel>End-Year Check-In</InputLabel>
                            <Select
                                value={endYearDate}
                                label='End-Year Check-In'
                                onChange={(e) => {
                                    const monthSelected = months.indexOf(e.target.value)
                                    setEndYearDate(e.target.value)
                                    setEndYearEmpty({ error: false, errorText: '' })
                                    startDate ? (
                                        setPbData(prevStates => ({
                                            ...prevStates,
                                            end_year_checkin: moment.utc({
                                                year: startDate.year(),
                                                month: monthSelected,
                                                day: 1
                                            }).format('YYYY-MM-DD')
                                        }))

                                    ) : (
                                        setPbData(prevStates => ({
                                            ...prevStates,
                                            end_year_checkin: moment.utc({
                                                year: new Date().getFullYear(),
                                                month: monthSelected,
                                                day: 1
                                            }).format('YYYY-MM-DD')
                                        }))

                                    )
                                }}
                            >
                                {monthsEndYearCheckin.length ?
                                    monthsEndYearCheckin.map((month, index) => (
                                        <MenuItem key={index} value={month}>{month}</MenuItem>

                                    )) : months.map((month, index) => (
                                        <MenuItem key={index} value={month}>{month}</MenuItem>
                                    ))}
                            </Select>
                            <FormHelperText>{endYearEmpty.errorText}</FormHelperText>
                        </FormControl>
                    </Stack>
                    <Stack spacing={4} mt={4}>
                        <Stack direction='row' spacing={2} style={{ alignContent: 'center' }}>
                            <TextField
                                id="end_date outlined-basic"
                                label="Goals Settings File"
                                value={url}
                                required
                                helperText={pdfEmpty.errorText}
                                error={pdfEmpty.error}
                                variant='standard'
                                onChange={(e) => {
                                    setUrl(e.target.value)
                                    setPdfEmpty({ error: false, errorText: '' })
                                    setPbData(prevStates => ({ ...prevStates, file_url: e.target.value }))
                                }}
                                sx={{ width: '95%' }}
                            />
                            <IconButton onClick={() => window.open(url)}>
                                <LaunchIcon size='small' />
                            </IconButton>
                        </Stack>
                        <Stack spacing={1}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Email Message
                            </Typography>
                            <RichtextFormatter
                                initialValue={emailText}
                                setComment={(content) => {
                                    const serialized = JSON.stringify(content)
                                    setEmailText(serialized)
                                    setPbData(prevStates => ({
                                        ...prevStates,
                                        email_message: serialized
                                    }))
                                }}
                                label="Enter email message..."
                            />
                        </Stack>
                        <Stack spacing={2}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Slack Message
                            </Typography>
                            <TextField
                                label="Slack Title"
                                variant="outlined"
                                fullWidth
                                value={slackObject.title}
                                onChange={(e) => {
                                    setSlackObject(prev => ({ ...prev, title: e.target.value }))
                                    setPbData(prevStates => ({
                                        ...prevStates,
                                        slack_message: { ...slackObject, title: e.target.value }
                                    }))
                                }}
                            />
                            <TextField
                                label="Slack Message"
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={4}
                                value={slackObject.message}
                                onChange={(e) => {
                                    setSlackObject(prev => ({ ...prev, message: e.target.value }))
                                    setPbData(prevStates => ({
                                        ...prevStates,
                                        slack_message: { title: slackObject.title, message: e.target.value }
                                    }))
                                }}
                            />
                        </Stack>

                        <Stack direction='row' spacing={2} justifyContent='end'>
                            <Button
                                onClick={() => {
                                    // setPeopleBuilderSettingsForm(false)
                                    setOpenPeopleBuilderForm(false)
                                }}
                                variant="contained"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    peopleBuilderId ?
                                        updatePeopleBuilderSettings({
                                            id: peopleBuilderId,
                                            data: pbData,
                                            startDate,
                                            endDate,
                                            pbData,
                                            slackObject,
                                            emailText,
                                            setOpenBackdrop,
                                            setPeopleBuilderSettings,
                                            setOpenPeopleBuilderForm,
                                            openAlert
                                        }) :
                                        createPeopleBuilderSettings({
                                            startDate,
                                            endDate,
                                            pbData,
                                            slackObject,
                                            url,
                                            peopleBuilderSettings,
                                            setOpenBackdrop,
                                            setPeopleBuilderSettings,
                                            setOpenPeopleBuilderForm,
                                            openAlert,
                                            validationSetters: {
                                                setStartDateEmpty,
                                                setEndDateEmpty,
                                                setMidYearEmpty,
                                                setEndYearEmpty,
                                                setPdfEmpty
                                            }
                                        })
                                }}
                                variant="contained"
                            >
                                Save</Button>
                        </Stack>
                    </Stack>
                </FormControl>
            </CardContent>
        </Card>
    )
}

export default NewPeopleBuilderSettings